import { Controller } from '@hotwired/stimulus'
import { on } from '../lib/events'

export default class extends Controller {
  static targets = ['click', 'menu']
  static values = { open: Boolean }

  connect = () => {
    on('click', this.closeMenu)
  }

  toggleMenu = () => {
    const element = this.menuTarget
    const dropdownClasses = element.dataset.dropdownClasses

    if (dropdownClasses) {
      const classNames = dropdownClasses.split(' ')
      classNames.forEach(className => element.classList.toggle(className))
      this.openValue = !this.openValue
    }
  }

  closeMenu = (event) => {
    if (this.canCloseMenu(event)) {
      event.preventDefault()
      this.toggleMenu()
    }
  }

  canCloseMenu = (event) => {
    return !event.target.closest('[data-dropdown-target="menu"]')
      && !event.target.closest('[data-dropdown-target="click"]')
      && this.openValue
  }
}
